<template>
  <div :class="$style.root">
    <div :class="[$style.key, rtlClasses]">
      {{ text }}
    </div>
    <Currency
      :class="$style.value"
      :value="value"
    />
    <div :class="$style.color" />
  </div>
</template>

<script>
import { string, number } from 'vue-types';

import Currency from '@/components/Currency.vue';
import { useRtlLocales } from '@/hooks/useRtlLocales';

export default {
  components: {
    Currency,
  },

  props: {
    text: string().isRequired,
    value: number().isRequired,
    color: string().def('rgba(92, 114, 163, 0.5)'),
  },

  setup() {
    const { rtlClasses } = useRtlLocales();

    return {
      rtlClasses,
    };
  },
};
</script>

<style lang="scss" module>
@import "~@/styles/variables.scss";

.root {
  display: flex;
  align-items: center;
}

.key {
  font-size: 13px;
  color: $color-text-light;
  margin-right: auto;
}

.value {
  color: $color-black;
  font-size: 15px;
  font-weight: bold;
  margin-right: 6px;
}

.color {
  background-color: v-bind(color);
  width: 6px;
  height: 6px;
  border-radius: 10px;
}
</style>
